// extracted by css-extract-rspack-plugin
var _1 = "oa6K4K4GgD6HoEl4STj3sA--";
export { _1 as "wrapper" }
